import React from 'react';

const CookiePolicy = () => {
  return (
    <div style={styles.pageWrapper}>
      <div style={styles.container}>
        <h1 style={styles.title}>Cookie Policy — Billy28.live</h1>
        <p style={styles.updated}>Last updated: 30.1.2026</p>
        <p style={styles.intro}>
          Billy28.live uses cookies to make the site work properly and to understand how it is used.
        </p>

        <h2 style={styles.heading}>1. What are cookies?</h2>
        <p style={styles.text}>
          Cookies are small text files stored on your device when you visit a website. They help websites function correctly and, in some cases, provide information about how the site is used.
        </p>

        <h2 style={styles.heading}>2. Essential cookies</h2>
        <p style={styles.text}>These cookies are required for Billy28.live to function.</p>
        <p style={styles.text}>They enable things like:</p>
        <ul style={styles.list}>
          <li>Secure access to the site</li>
          <li>Payments and checkout</li>
          <li>Streaming and session stability</li>
          <li>Basic security and fraud prevention</li>
        </ul>
        <p style={styles.text}>These cookies cannot be switched off.</p>

        <h2 style={styles.heading}>3. Analytics cookies</h2>
        <p style={styles.text}>
          We use analytics cookies to understand how people use Billy28.live so we can improve the experience.
        </p>
        <p style={styles.text}>These cookies help us see things like:</p>
        <ul style={styles.list}>
          <li>Pages visited</li>
          <li>Time spent on the site</li>
          <li>General usage patterns</li>
        </ul>
        <p style={styles.text}>
          Analytics cookies are only set if you choose to accept them via the cookie banner.
        </p>

        <h2 style={styles.heading}>4. Managing your preferences</h2>
        <p style={styles.text}>
          You can choose whether to allow analytics cookies when you visit the site.
        </p>
        <p style={styles.text}>
          You can also change your preferences at any time using the Preferences option in the cookie banner.
        </p>

        <h2 style={styles.heading}>5. Contact</h2>
        <p style={styles.text}>
          If you have questions about this cookie policy, you can contact us at:
        </p>
        <p style={styles.text}>
          <a href="mailto:support@fullaccess.live" style={styles.link}>support@fullaccess.live</a>
        </p>
      </div>
    </div>
  );
};

const styles = {
  pageWrapper: {
    minHeight: '100vh',
    backgroundColor: '#0a0a0a',
    color: '#ffffff',
    fontFamily: "'Roboto', sans-serif",
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  container: {
    maxWidth: 700,
    width: '100%',
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 8,
  },
  updated: {
    fontSize: 14,
    color: '#888',
    marginBottom: 32,
  },
  intro: {
    fontSize: 16,
    lineHeight: 1.6,
    marginBottom: 32,
  },
  heading: {
    fontSize: 20,
    fontWeight: 600,
    marginTop: 32,
    marginBottom: 12,
  },
  text: {
    fontSize: 16,
    lineHeight: 1.6,
    marginBottom: 8,
    color: '#ddd',
  },
  list: {
    paddingLeft: 24,
    marginBottom: 12,
    color: '#ddd',
    lineHeight: 1.8,
  },
  link: {
    color: '#C8102E',
    textDecoration: 'underline',
  },
};

export default CookiePolicy;
